<template>
  <div>
    <SelectFormGroup
        v-model="data.platform"
        name="platform"
        label="Platform"
        :error="(errors.platform || [])[0]"
        :options="platformOptions"
    />

    <TextFormGroup
        v-model="data.src"
        name="src"
        label="src"
        :error="(errors.src || [])[0]"
        help-text="The src field of the code snippet from the social media platform."
    />
  </div>
</template>

<script>
import TextFormGroup from "../../../../vendor/forms/FormGroups/Block/Text.vue";
import SelectFormGroup from "../../../../vendor/forms/FormGroups/Block/Select.vue";

export default {
  components: {TextFormGroup,SelectFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  computed: {
    data: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      }
    },

    platformOptions() {
      return [
        {value: 'instagram', label: 'Instagram'},
        {value: 'facebook', label: 'Facebook'},
        {value: 'linkedin', label: 'LinkedIn'},
        {value: 'twitter', label: 'Twitter'},
        {value: 'pinterest', label: 'Pinterest'}
      ]
    }
  }
}
</script>
